// Runtime settings keys
export const DISTANCE_CALCULATING_ENABLED_CONFIG_KEY = 'distance-calculating.enabled';
export const ROUTE_ONBOARDING_CONFIG_KEY = 'distance-calculating.onboardingEnabled';
export const YANDEX_API_KEY_CONFIG_KEY = 'builders.YandexApiKey';
export const YANDEX_VERSION_CONFIG_KEY = 'builders.YandexApiVersion';

export const MAX_DISPLAY_ONBOARDING_COUNT = 3;
export const ROUTE_ONBOARDING_STORAGE_KEY = 'distance_calculating_onboarding_counter';
export const YANDEX_API_TELEMETRY_KEY = 'yandexApi.requestsCount';

export const MAX_DISPLAY_FUTURE_MAP_ONBOARDING_COUNT = 3;
export const FUTURE_MAP_ONBOARDING_CONFIG_KEY = 'future-map.onboardingEnabled';
export const FUTURE_MAP_ONBOARDING_COOKIE_KEY = 'future_map_onboarding_counter';

export const MAP_CONTAINER_ID = 'mapsSection';
